import { Component, OnInit, Input, Output, EventEmitter, ɵConsole } from '@angular/core';
import { MainService } from 'src/app/services/delavci/main.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MonitorService } from 'src/app/services/delavci/monitor/monitor.service';
import { MapModel } from 'src/app/models/MapModel';

@Component({
  selector: 'app-setting-bar',
  templateUrl: './setting-bar.component.html',
  styleUrls: ['./setting-bar.component.css']
})
export class SettingBarComponent implements OnInit {

  public nastavitveFromService = false;
  public settingsForm: UntypedFormGroup;
  public values = '';
  public checkboxesFilter = [ {name: 'gray', selected: false},
                              {name: 'red', selected: false},
                              {name: 'orange', selected: false},
                              {name: 'green', selected: false} ];
  public filterWaiting = false;
  public globalMapAfterFilter: Array<MapModel> = [];
  @Input() public globalMap: any[] = [];
  //public globalMap: Array<MapModel> = [];
  @Input() public ticks: any[] = [];
  @Output() public submitted = new EventEmitter<boolean>();
  @Output() public voiceToggle = new EventEmitter<boolean>();
  public toggle: boolean;
  public spinnerNoWhite: boolean;
  @Input() public didRefresh: boolean;
  public filtrirajKategorijo = 'Serv';
  constructor(private mainService: MainService, private monitorService: MonitorService) {
    this.settingsForm = new UntypedFormGroup(
      {
        timeToUpdate: new UntypedFormControl('', [Validators.pattern("^[0-9]*$")]),
        fontSize: new UntypedFormControl('', [Validators.pattern("^[0-9]*$")]),
        positionOnBack: new UntypedFormControl('', [Validators.pattern("^[0-9]*$")])
      }
    );
    this.toggle = this.monitorService.currentSoundSettingValue;
   }

  ngOnInit() {
    this.monitorService.currentFilterObject.subscribe(data => {
      if(data) {
        this.checkboxesFilter = data[0].checkboxesFilter;
        this.filtrirajKategorijo = data[1].filtrirajKategorijo;
        this.values = data[2].textFilter;
      }
    });
    if (this.monitorService.currentSoundSettingValue == null) {
      this.toggle = true;
    } else {
      this.toggle = this.monitorService.currentSoundSettingValue;
    }
    sessionStorage.clear();
    //this.globalMap = this.monitorService.currentGlobalMapValue;
    this.spinnerNoWhite = true;
    this.mainService.nastavitveClickBool.subscribe( message => this.nastavitveFromService = message);
    setTimeout(() => {
      this.spinnerNoWhite = false;
    }, 500);

  }


  get getFormFields() {
    return this.settingsForm.controls;
  }

  //Nastavim sound, ki se izvede če je kaj v rdečem
  onVoice() {

  if (this.toggle) {
    this.voiceToggle.emit(false);
    this.toggle = false;
    this.monitorService.setCurrentSoundSettings(this.toggle);
  } else {
    this.toggle = true;
    this.voiceToggle.emit(true);
    this.monitorService.setCurrentSoundSettings(this.toggle);
  }
}

    //ko potrdim nastavitve TIMERJA
  onSubmit() {
    //vrne prazno
    if (this.settingsForm.invalid) {
      return console.log('invalid');
    }
    if (this.settingsForm.value.timeToUpdate.length != 0) {
      this.monitorService.newUpdateTime(this.settingsForm.value.timeToUpdate);
    }
    if (this.settingsForm.value.fontSize.length != 0) {
      this.monitorService.newFontSize(this.settingsForm.value.fontSize);
    }
    if (this.settingsForm.value.positionOnBack.length != 0) {
      this.monitorService.setCurrentFilterMonitorRowPosition(this.settingsForm.value.positionOnBack);
    }

    location.href = location.href;

    this.submitted.emit(true);
  }

  filterAgain() {
    let replacedSpaces = this.values.replace(' ', '_');
    let filterObj: Array<any> = [{checkboxesFilter: this.checkboxesFilter}, {filtrirajKategorijo: this.filtrirajKategorijo},
    {textFilter: replacedSpaces}];
    this.monitorService.setCurrentFilterObject(filterObj);
  }

   //filter
   onFilterSearch(event: any) {
    /*if((event.target as HTMLInputElement).value != ' '){
      this.values = (event.target as HTMLInputElement).value;
    } else {
      this.values += '_';
    }*/
    this.values = event.target.value;
    if (this.values === '' && event.keyCode === 8 || event.keyCode === 20 ) {
      this.filterWaiting = true;
      //this.valuesEmitter.emit(this.values);
    } else {
     // this.valuesEmitter.emit(this.values);
    }
  }


  onCheckboxClick(color: string) {
    for(let i = 0; i < this.checkboxesFilter.length; i++) {
      if (this.checkboxesFilter[i].name === color) {
        if (this.checkboxesFilter[i].selected) {
          this.checkboxesFilter[i].selected = false;
        } else {
          this.checkboxesFilter[i].selected = true;
        }
      }
    }
  //  this.checkboxEmitter.emit(this.checkboxesFilter);
  }

  dropdown(value: string) {
    this.filtrirajKategorijo = value;
  //  this.valuesEmitter.emit(this.values);
  //  this.filtrirajPo.emit(this.filtrirajKategorijo);
  }
}
